import navigationIcon from '@/assets/images/icon-navigate@2x.png';
import navigationRotate from '@/assets/images/rotate@2x.png';
import styles from '../../index.module.scss';

const NavigationHome = () => (
  <div className={styles.navigationWelcome}>
    <div className={styles.homeTitle}>
      欢迎使用
      <span className={styles.title}>智能导航</span>
    </div>
    <div className={styles.desc}>支持输入业务需求，快速定位系统内匹配的功能页面</div>
    <div className={styles.navigationGraphic} aria-hidden="true">
      <img className={styles.navigationIcon} src={navigationIcon} alt="" />
      <img className={styles.navigationRotate} src={navigationRotate} alt="" />
    </div>
  </div>
);

export default NavigationHome;
